var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 75,
    viewBox: "0 0 90 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 24.8684H2.36842C1.18421 24.8684 0 23.6842 0 22.5C0 21.3158 1.18421 20.1316 2.36842 20.1316H45C49.7368 20.1316 53.2895 16.5789 53.2895 11.8421C53.2895 9.47368 50.9211 7.10526 48.5526 7.10526H47.3684C45 7.10526 42.6316 9.47368 42.6316 11.8421C42.6316 13.0263 41.4474 14.2105 40.2632 14.2105C39.0789 14.2105 37.8947 13.0263 37.8947 11.8421C36.7105 4.73684 41.4474 0 47.3684 0H48.5526C54.4737 0 59.2105 4.73684 59.2105 10.6579C59.2105 18.9474 53.2895 24.8684 45 24.8684Z",
    fill: "url(#paint0_linear_57_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5526 74.6052C41.4474 74.6052 36.7105 69.8684 36.7105 63.9473C36.7105 62.7631 37.8947 61.5789 39.0789 61.5789C40.2632 61.5789 41.4474 62.7631 41.4474 63.9473C41.4474 66.3157 43.8158 68.6842 46.1842 68.6842H47.3684C49.7368 68.6842 52.1053 66.3157 52.1053 63.9473C52.1053 59.2105 48.5526 55.6578 43.8158 55.6578H2.36842C1.18421 55.6578 0 53.2894 0 52.1052C0 50.921 1.18421 49.7368 2.36842 49.7368H45C53.2895 49.7368 59.2105 55.6578 59.2105 63.9473C59.2105 69.8684 54.4737 74.6052 48.5526 74.6052Z",
    fill: "url(#paint1_linear_57_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7895 40.2632H2.36842C1.18421 40.2632 0 39.0789 0 36.7105C0 35.5263 1.18421 34.3421 2.36842 34.3421H75.7895C80.5263 34.3421 84.0789 30.7895 84.0789 26.0526C84.0789 23.6842 81.7105 21.3158 79.3421 21.3158H78.1579C75.7895 21.3158 73.4211 23.6842 73.4211 26.0526C73.4211 27.2368 72.2368 28.421 71.0526 28.421C69.8684 28.421 67.5 27.2368 67.5 26.0526C67.5 20.1316 72.2368 15.3947 78.1579 15.3947H79.3421C85.2632 15.3947 90 20.1316 90 26.0526C90 34.3421 84.0789 40.2632 75.7895 40.2632Z",
    fill: "url(#paint2_linear_57_318)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_318",
    x1: 0,
    y1: 12.5538,
    x2: 59.2224,
    y2: 12.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#729FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_318",
    x1: 0,
    y1: 62.0147,
    x2: 59.2224,
    y2: 62.0147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#729FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_318",
    x1: 0,
    y1: 27.5755,
    x2: 90.5672,
    y2: 27.5755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4397,
    stopColor: "#729FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D2FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 74.6053,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.48c79800fc5c9090a9a5b45399d3e57c.svg";
export { ForwardRef as ReactComponent };